(function() {
  // "Shown in: {Color}" pinned to the media slide of the SELECTED variant.
  // Live-updates via theme pubsub, click/change listeners, and a light polling fallback
  // (themes often set inputs programmatically, which fires no change event).

  function getGallery() {
    return document.querySelector('.product .splide__gallery, .product [data-media-id], .splide__gallery');
  }

  function getScope() {
    var gallery = getGallery();
    if (!gallery) return null;
    var node = gallery.parentElement;
    while (node && node !== document.body) {
      if (node.querySelector('variant-selects')) return node;
      node = node.parentElement;
    }
    return document;
  }

  function getColorValue(scope) {
    function search(root) {
      var fieldsets = root.querySelectorAll('variant-selects fieldset');
      for (var i = 0; i < fieldsets.length; i++) {
        var label = fieldsets[i].querySelector('.form__label');
        if (!label) continue;
        if (!/^colou?r\s*:/i.test((label.textContent || '').trim())) continue;
        var checked = fieldsets[i].querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
        if (checked && checked.value) return checked.value;
        var valEl = label.querySelector('.form__label-value');
        if (valEl && valEl.textContent.trim()) return valEl.textContent.trim();
      }
      var labels = root.querySelectorAll('variant-selects .form__label');
      for (var k = 0; k < labels.length; k++) {
        var t = (labels[k].textContent || '').trim();
        if (/^colou?r\s*:/i.test(t)) {
          var v = labels[k].querySelector('.form__label-value');
          if (v && v.textContent.trim()) return v.textContent.trim();
          var rest = t.split(':').slice(1).join(':').trim();
          if (rest) return rest;
        }
      }
      return null;
    }
    var result = search(scope || document);
    if (!result && scope && scope !== document) result = search(document);
    return result;
  }

  function getTargetSlide(scope) {
    var root = scope === document ? document : scope;
    return (
      root.querySelector('.splide__slide[data-selected="true"] .product-media-container') ||
      root.querySelector('.splide__slide--current-variant .product-media-container') ||
      root.querySelector('.splide__slide.is-active .product-media-container') ||
      root.querySelector('.product-media-container')
    );
  }

  var applying = false;
  function apply() {
    if (applying) return;
    applying = true;
    try {
      var scope = getScope();
      if (!scope) return;
      var color = getColorValue(scope);
      var root = scope === document ? document : scope;
      var box = root.querySelector('.info-in-media');
      if (!color) {
        if (box && box.dataset.jbShownIn) box.style.display = 'none';
        return;
      }
      var target = getTargetSlide(scope);
      if (!target) return;
      if (!box) {
        box = document.createElement('div');
        box.className = 'info-in-media absolute text-size-tiny';
        box.dataset.jbShownIn = '1';
      }
      if (box.parentElement !== target) target.appendChild(box);
      var next = 'Shown in: ' + color;
      if (box.textContent.trim() !== next) box.textContent = next;
      box.style.display = '';
    } finally {
      applying = false;
    }
  }

  function applySoon() {
    setTimeout(apply, 50);
    setTimeout(apply, 250);
    setTimeout(apply, 700);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  window.addEventListener('load', apply);

  // 1) Native change events (dropdowns, some pickers)
  document.addEventListener('change', function(e) {
    if (e.target.closest && e.target.closest('variant-selects, .variant-picker')) applySoon();
  });

  // 2) Clicks on swatches/labels — themes often set inputs programmatically (no change event)
  document.addEventListener('click', function(e) {
    if (e.target.closest && e.target.closest('variant-selects label, variant-selects .swatch-image, variant-selects .swatch-block, .variant-picker label')) applySoon();
  });

  // 3) Theme pubsub, if exposed
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      if (PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, applySoon);
      if (PUB_SUB_EVENTS.optionValueSelectionChange) subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, applySoon);
    }
  } catch (err) { /* noop */ }

  // 4) Polling fallback: reapply whenever the selected color or slide changes
  var lastKey = '';
  setInterval(function() {
    var scope = getScope();
    if (!scope) return;
    var color = getColorValue(scope) || '';
    var slide = getTargetSlide(scope);
    var slideId = slide && slide.closest('[data-media-id]') ? slide.closest('[data-media-id]').getAttribute('data-media-id') : '';
    var key = color + '|' + slideId;
    if (key !== lastKey) {
      lastKey = key;
      apply();
    }
  }, 400);

  new MutationObserver(function() { apply(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
